/* Andra Andreescu product page (our own file, section aa-product).
   Hides description lines that are only a placeholder ("…", or "Model wears: …"); shows the chosen variant's price and keeps it
   in the address; asks for a choice, in words, if Add to bag is pressed without one; counts the photos on phones.
   Technician fix, 28 Oct night: products with two options (Size + Colour) have one group per option; this file finds the
   matching variant, writes its id into the form, and says so when a combination does not exist or is not available.
   28 Oct (late): 4. photo zoom, a full-screen viewer on white (second block below).
   28 Oct, product page v2: 3. the counter also works with two photos across (tablet) and is read out politely once a swipe
   settles; 5. folds open one at a time; 6. the slim Add to bag bar for phones and tablets (same form, same checks).
   In the viewer, a downward swipe on the unzoomed photo closes it (phones).
   29 Oct, mood board photos: the photo counter (3) is gone, as the sideways strip it counted; the board itself is laid out by the
   inline script in sections/aa-product.liquid (it must run before the first paint). The viewer takes the photos in the order
   they are on screen when it opens, and on closing brings the last photo seen into view. */
(function(){
'use strict';
const root=document.querySelector('[data-aa-pdp]'); if(!root)return;

/* 1. placeholder lines in the description */
const PH=/^\s*([^:]{0,60}:)?\s*(…|\.\.\.)\s*$/;
const desc=root.querySelector('[data-aa-desc]');
if(desc){
  desc.querySelectorAll('p,li,div,span,h2,h3,h4,h5,h6').forEach(el=>{
    if(el.children.length===0||[...el.childNodes].every(n=>n.nodeType===3||n.nodeName==='BR'||n.nodeName==='STRONG'||n.nodeName==='B'||n.nodeName==='EM')){
      if(el.querySelector('br')){
        const lines=el.innerHTML.split(/<br\s*\/?>/i), keep=lines.filter(h=>{const t=document.createElement('div');t.innerHTML=h;return !PH.test(t.textContent)});
        if(keep.length!==lines.length)el.innerHTML=keep.join('<br>');
      }
      if(PH.test(el.textContent)||!el.textContent.trim()&&!el.querySelector('img,iframe,video'))el.remove();
    }
  });
  [...desc.childNodes].forEach(n=>{if(n.nodeType===3&&PH.test(n.textContent))n.remove()});
  if(!desc.textContent.trim()&&!desc.querySelector('img,iframe,video')){const f=root.querySelector('[data-aa-desc-fold]'); f&&f.remove()}
}

/* 2. choice: price, address, reminder */
const form=document.getElementById('aa-pdp-form');
const price=root.querySelector('[data-aa-price]'), was=root.querySelector('[data-aa-was]'), need=root.querySelector('[data-aa-need]');
const none=root.querySelector('[data-aa-none]'), mtmNote=root.querySelector('[data-aa-mtm-note]'), add=root.querySelector('[data-aa-add]');
function show(p,w){ if(price&&p)price.textContent=p; if(was){was.textContent=w||''; was.hidden=!w} }
/* a11y (audit 2): an error line that only un-hides a role="alert" is not reliably read by VoiceOver, so it is also said through
   AASay (aa-grid.js, when on the page) and tied to its group with aria-describedby while it shows */
function warn(el){ if(!el)return; el.hidden=false; const fs=el.closest('fieldset')||form&&form.querySelector('[data-aa-option]');
  if(fs&&el.id)fs.setAttribute('aria-describedby',el.id); if(window.AASay)window.AASay(el.textContent) }
function calm(el){ if(!el)return; el.hidden=true; if(form&&el.id)form.querySelectorAll('[aria-describedby="'+el.id+'"]').forEach(f=>f.removeAttribute('aria-describedby')) }
function setUrl(id){ try{const u=new URL(location.href); if(id)u.searchParams.set('variant',id); else u.searchParams.delete('variant'); history.replaceState(history.state,'',u)}catch(e){} }

const idInput=form&&form.querySelector('[data-aa-id]');
let firstMissing=()=>null;   // the option group still to choose, for the slim bar (6)
if(form&&idInput){
  /* two or more options */
  let variants=[]; try{variants=JSON.parse(root.querySelector('[data-aa-variants]').textContent)}catch(e){}
  const groups=[...form.querySelectorAll('[data-aa-option]')];
  const chosen=()=>groups.map(g=>{const r=g.querySelector('input[type="radio"]:checked'); return r?r.value:null});
  function sync(){
    const vals=chosen(), complete=vals.every(v=>v!==null);
    if(mtmNote)mtmNote.hidden=!groups.some(g=>{const r=g.querySelector('input:checked'); return r&&r.dataset.mtm==='true'});
    if(need&&complete)calm(need);
    if(!complete){idInput.value=''; calm(none); if(add)add.disabled=false; return}
    const v=variants.find(x=>x.o.length===vals.length&&x.o.every((o,i)=>o===vals[i]));
    if(v&&v.a){idInput.value=String(v.id); show(v.p,v.w); calm(none); if(add)add.disabled=false; setUrl(v.id)}
    else{idInput.value=''; if(v)show(v.p,v.w); warn(none); if(add)add.disabled=true; setUrl(null)}
  }
  firstMissing=()=>{ const gi=chosen().findIndex(v=>v===null); return gi>-1?groups[gi]:null };
  groups.forEach(g=>g.addEventListener('change',sync));
  /* fix 3 (31 Oct, tech #4): choosing a colour brings that colour's photo into view (laptops, where the photos sit beside the choices;
     on phones the page does not jump away from the choices). Only an option whose values each have their own photo counts as a colour. */
  const photosEl=root.querySelector('[data-aa-photos]'), wide=matchMedia('(min-width: 1000px)');
  if(photosEl&&new Set(variants.map(v=>v.m)).size>1)groups.forEach((g,gi)=>g.addEventListener('change',e=>{
    const r=e.target; if(!r||r.type!=='radio'||!wide.matches)return;
    const ms=new Set(variants.filter(v=>v.o[gi]===r.value).map(v=>v.m)); if(ms.size!==1)return; const m=[...ms][0]; if(!m)return;
    const li=photosEl.querySelector('[data-media-id="'+m+'"]'); if(!li)return;
    const b=li.getBoundingClientRect(), top=parseFloat(getComputedStyle(document.documentElement).getPropertyValue('scroll-padding-top'))||80;
    if(b.top>=top-1&&b.bottom<=innerHeight+1)return;
    li.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'})}));
  form.querySelectorAll('[data-aa-option] input').forEach(r=>r.addEventListener('invalid',e=>{e.preventDefault(); warn(need)}));
  form.addEventListener('submit',e=>{ if(!idInput.value){e.preventDefault();
    const vals=chosen(), gi=vals.findIndex(v=>v===null);
    if(gi>-1){warn(need); const f=groups[gi].querySelector('input'); f&&f.focus()} else warn(none) }});
  sync();
}else if(form){
  /* one option: one radio per variant, name="id" (works without JavaScript) */
  const radios=[...form.querySelectorAll('input[type="radio"][name="id"]')];
  function syncOne(r){ if(!r)return; show(r.dataset.price,r.dataset.was); calm(need);
    if(mtmNote)mtmNote.hidden=r.dataset.mtm!=='true'; setUrl(r.value) }
  radios.forEach(r=>r.addEventListener('change',()=>syncOne(r)));
  if(radios.length){
    firstMissing=()=>radios.some(r=>r.checked)?null:radios[0].closest('fieldset');
    radios.forEach(r=>r.addEventListener('invalid',e=>{e.preventDefault(); warn(need)}));
    form.addEventListener('submit',e=>{ if(!radios.some(r=>r.checked)){e.preventDefault(); warn(need); const f=radios.find(r=>!r.disabled); f&&f.focus()} });
  }
  radios.forEach(r=>{if(r.checked&&mtmNote)mtmNote.hidden=r.dataset.mtm!=='true'});
}

/* "Size guide": opens the Size & fit fold and scrolls to it (without JavaScript the link still jumps there) */
const fit=document.getElementById('aa-fit'), guide=root.querySelector('[data-aa-guide]');
function openFit(smooth){ if(!fit)return; fit.open=true; fit.scrollIntoView({behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'auto',block:'start'}); const s=fit.querySelector('summary'); s&&s.focus({preventScroll:true}) }
guide&&guide.addEventListener('click',e=>{e.preventDefault(); openFit(true); try{history.replaceState(history.state,'','#aa-fit')}catch(_){}});
if(location.hash==='#aa-fit')openFit(false);

/* 3. (photo counter: removed 29 Oct with the sideways strip; the photos now sit one under the other, or as a mood board) */
const reduceMotion=matchMedia('(prefers-reduced-motion: reduce)');

/* 5. folds: one open at a time (the browser does it with details[name]; this covers browsers that do not) */
const folds=[...root.querySelectorAll('[data-aa-fold]')];
folds.forEach(d=>d.addEventListener('toggle',()=>{ if(d.open)folds.forEach(o=>{ if(o!==d&&o.open)o.open=false }) }));

/* 6. slim Add to bag bar (phones and tablets, under 1000 px). It shows whenever the main Add to bag is off screen, but never over
   the first photo, and hides while the footer is in view. Its button uses the same form: with a size
   (or another option) still to choose, it scrolls back to that choice and says so; otherwise it presses the main button. */
const bar=root.querySelector('[data-aa-bar]'), barAdd=bar&&bar.querySelector('[data-aa-bar-add]'), barPrice=bar&&bar.querySelector('[data-aa-bar-price]');
if(bar&&add&&form&&'IntersectionObserver' in window){
  document.body.appendChild(bar);   // out of the page grid, so the sticky column can never hold it
  const small=matchMedia('(max-width: 999px)'), foot=document.getElementById('foot');
  let addGone=false, footIn=false;
  function place(){ const on=small.matches&&addGone&&!footIn&&!document.documentElement.classList.contains('aa-zv-open');
    bar.classList.toggle('is-on',on); bar.inert=!on; if(!on&&bar.contains(document.activeElement))add.focus({preventScroll:true}) }
  /* 29 Oct (design audit R2): on phones the name, price and Add to bag came only after ~4 full-width photos. The bar now also
     shows while the main button is still below the screen, once the first photo is mostly scrolled past (the first photo stays clean) */
  const p1=root.querySelector('.aa-pdp__photo');
  const gone=()=>{ const r=add.getBoundingClientRect(), vh=innerHeight;
    if(r.bottom<0)return true;                                   // scrolled away above
    if(r.top<vh)return false;                                    // on screen
    return !!p1&&p1.getBoundingClientRect().bottom<vh*.55 };     // still below, and the first photo is mostly past
  new IntersectionObserver(()=>{ addGone=gone(); place() }).observe(add);
  /* a jump straight past the button (an anchor, a fast fling) gives the observer no change to report, so a light check on scroll
     backs it up; capture catches the scroll of whichever box scrolls (the page, or Horizon's .page-wrapper from 990 px) */
  let sraf=0;
  document.addEventListener('scroll',()=>{ if(sraf||!small.matches)return; sraf=requestAnimationFrame(()=>{ sraf=0; const g=gone(); if(g!==addGone){addGone=g; place()} }) },{passive:true,capture:true});
  if(foot)new IntersectionObserver(es=>{ es.forEach(e=>{ footIn=e.isIntersecting }); place() }).observe(foot);
  /* audit 3 (29 Oct): the scroll check above only runs under 1000 px (the bar is never shown on laptops), so the state is read
     again when the window narrows */
  const onSmall=()=>{ addGone=gone(); place() };
  (small.addEventListener?small.addEventListener('change',onSmall):small.addListener(onSmall));
  new MutationObserver(place).observe(document.documentElement,{attributes:true,attributeFilter:['class']});
  if(price&&barPrice)new MutationObserver(()=>{barPrice.textContent=price.textContent}).observe(price,{childList:true,characterData:true,subtree:true});
  barAdd.addEventListener('click',()=>{
    const miss=firstMissing()||(add.disabled?form.querySelector('[data-aa-option]'):null);
    const go=el=>el.scrollIntoView({behavior:reduceMotion.matches?'auto':'smooth',block:'center'});
    if(miss){
      if(firstMissing()){ warn(need) } else warn(none);
      go(miss); const f=miss.querySelector('input:not([disabled])'); f&&f.focus({preventScroll:true}); return;
    }
    if(form.requestSubmit)form.requestSubmit(add); else add.click();
  });
}
})();

/* 4. Photo zoom (section aa-product, viewer #aa-zv). 28 Oct 2026 (late), a recommendation Andra can refuse.
   A photo button opens the viewer on that photo, fitted whole. Zoom is continuous: pinch (phones), wheel or trackpad, + / −,
   a click (mouse) or a double tap (touch) toggles between the whole photo and a close view; drag moves the photo; swipe
   (when not zoomed), the arrows or the arrow keys change photo. Esc or the cross closes it and focus goes back to the photo.
   The photo moves with transform only, eased in requestAnimationFrame (instant with "reduce motion").
   Sharpness: the viewer starts from the page's own photo, then a 2000 px version, and loads the original (up to Shopify's
   5760 px) only when zoomed past 1.3x. It never zooms past the point where one pixel of the photo would be larger than one
   pixel of the screen: maxScale = (photo width / fitted width in CSS px) / devicePixelRatio, at least 1, at most 8.
   Past that point a pinch gives a little, then settles back: the "soft stop". */
(function(){
'use strict';
const zv=document.querySelector('[data-aa-zv]');
const buttons=[...document.querySelectorAll('[data-aa-zoom-open]')];
if(!zv||!buttons.length)return;
document.body.appendChild(zv);   // out of the page, so no parent's stacking or scroll can clip it

const $=s=>zv.querySelector(s);
const stage=$('[data-aa-zv-stage]'), img=$('[data-aa-zv-img]');
const bClose=$('[data-aa-zv-close]'), bPrev=$('[data-aa-zv-prev]'), bNext=$('[data-aa-zv-next]');
const bIn=$('[data-aa-zv-in]'), bOut=$('[data-aa-zv-out]'), zoomGroup=$('[data-aa-zv-zoom]');
const nEl=$('[data-aa-zv-n]'), live=$('[data-aa-zv-live]'), countTpl=zv.dataset.count||'[n] / [t]';
const reduce=matchMedia('(prefers-reduced-motion: reduce)');
const CAP=8, BIG_AT=1.3, STEP=1.6, CLOSE_VIEW=2.5;
/* the photos in the order they are on screen (the mood board may put a wide photo first in its block; on phones it is
   Andra's order), read again each time the viewer opens */
let openers=[], photos=[], N=0;
function collect(){
  openers=[...document.querySelectorAll('[data-aa-zoom-open]')];
  photos=openers.map(b=>{const im=b.querySelector('img'); return {w:+b.dataset.w||0,h:+b.dataset.h||0,mid:b.dataset.mid||'',full:b.dataset.full||'',alt:im?im.alt:'',thumb:im}});
  N=photos.length;
}
collect();

let idx=0, opener=null, isOpen=false, token=0, bigState=0;   // bigState: 0 none, 1 loading, 2 shown
let W=0, H=0, fw=0, fh=0, maxS=1;
let cur={s:1,x:0,y:0}, tgt={s:1,x:0,y:0}, raf=0;

/* geometry */
function fit(){
  W=stage.clientWidth; H=stage.clientHeight;
  const p=photos[idx], ar=(p.w&&p.h)?p.w/p.h:.75;
  if(W/H>ar){fh=H; fw=H*ar}else{fw=W; fh=W/ar}
  img.style.width=fw+'px'; img.style.height=fh+'px'; img.style.marginLeft=(-fw/2)+'px'; img.style.marginTop=(-fh/2)+'px';
  const dpr=window.devicePixelRatio||1;
  maxS=p.w?Math.min(CAP,Math.max(1,p.w/fw/dpr)):1;
  if(zoomGroup)zoomGroup.hidden=maxS<1.05;
}
function clampT(t){ const mx=Math.max(0,(fw*t.s-W)/2), my=Math.max(0,(fh*t.s-H)/2);
  t.x=Math.min(mx,Math.max(-mx,t.x)); t.y=Math.min(my,Math.max(-my,t.y)); return t }
function rel(cx,cy){ const r=stage.getBoundingClientRect(); return [cx-r.left-W/2, cy-r.top-H/2] }

/* drawing */
function apply(){ img.style.transform='translate3d('+cur.x.toFixed(2)+'px,'+cur.y.toFixed(2)+'px,0) scale('+cur.s.toFixed(4)+')' }
function state(){
  zv.classList.toggle('is-zoomed',tgt.s>1.01);
  // a11y (audit 2): aria-disabled, not disabled, so a focused button keeps the focus when it reaches its limit
  if(bIn)bIn.setAttribute('aria-disabled',String(tgt.s>=maxS-.01));
  if(bOut)bOut.setAttribute('aria-disabled',String(tgt.s<=1.01));
}
function tick(){
  raf=0; let done=true;
  ['s','x','y'].forEach(k=>{ const d=tgt[k]-cur[k];
    if(Math.abs(d)>(k==='s'?.0008:.25)){cur[k]+=d*.2; done=false} else cur[k]=tgt[k] });
  apply(); if(!done)raf=requestAnimationFrame(tick);
}
function go(now){ state();
  if(now||reduce.matches){ cancelAnimationFrame(raf); raf=0; cur={s:tgt.s,x:tgt.x,y:tgt.y}; apply(); return }
  if(!raf)raf=requestAnimationFrame(tick) }
function zoomAt(s,px,py,now){
  s=Math.min(maxS,Math.max(1,s)); const r=s/tgt.s;
  tgt.x=px-(px-tgt.x)*r; tgt.y=py-(py-tgt.y)*r; tgt.s=s; clampT(tgt); go(now); big(s) }
function reset(now){ tgt={s:1,x:0,y:0}; go(now) }

/* sharper versions: 2000 px first, the original only when zoomed */
function load(src,then){ const t=token, im=new Image(); im.decoding='async'; im.src=src;
  (im.decode?im.decode():new Promise((ok,no)=>{im.onload=ok; im.onerror=no})).then(()=>{ if(t===token)then() }).catch(()=>{}) }
function big(s){ const p=photos[idx];
  if(s>BIG_AT&&bigState===0&&p.full&&p.full!==p.mid){ bigState=1; load(p.full,()=>{ img.src=p.full; bigState=2 }) } }

/* one photo */
function show(i,first){
  token++; bigState=0; idx=(i+N)%N; const p=photos[idx];
  const put=()=>{
    img.style.opacity=''; img.alt=p.alt; img.src=(p.thumb&&p.thumb.currentSrc)||p.mid||p.full;
    fit(); reset(true);
    if(p.mid&&img.src!==p.mid)load(p.mid,()=>{ if(bigState<2)img.src=p.mid });
    img.classList.remove('is-swapping');
  };
  if(first||reduce.matches)put(); else{ img.classList.add('is-swapping'); setTimeout(put,150) }
  if(nEl)nEl.textContent=(idx+1)+' / '+N;
  if(live)live.textContent=N>1?countTpl.replace('[n]',idx+1).replace('[t]',N):'';
}

/* open / close */
const wrap=document.querySelector('.page-wrapper');
function open(i,btn){
  opener=btn; isOpen=true; zv.hidden=false;
  document.documentElement.classList.add('aa-zv-open'); document.documentElement.setAttribute('scroll-lock','');
  if(wrap)wrap.inert=true;
  show(i,true);
  requestAnimationFrame(()=>zv.classList.add('is-on'));
  bClose&&bClose.focus({preventScroll:true});
}
function close(){
  if(!isOpen)return; isOpen=false; token++;
  zv.classList.remove('is-on');
  document.documentElement.classList.remove('aa-zv-open'); document.documentElement.removeAttribute('scroll-lock');
  if(wrap)wrap.inert=false;
  setTimeout(()=>{ if(!isOpen)zv.hidden=true }, reduce.matches?0:260);
  const back=openers[idx]||opener;
  if(back){ const r=back.getBoundingClientRect();   // the last photo seen, brought into view if it is off the screen
    if(r.bottom<0||r.top>innerHeight)back.scrollIntoView({block:'center',behavior:'auto'});
    back.focus({preventScroll:true}) }
}
buttons.forEach(b=>b.addEventListener('click',()=>{ collect(); open(Math.max(0,openers.indexOf(b)),b) }));
bClose&&bClose.addEventListener('click',close);
bPrev&&bPrev.addEventListener('click',()=>show(idx-1));
bNext&&bNext.addEventListener('click',()=>show(idx+1));
bIn&&bIn.addEventListener('click',()=>{ if(bIn.getAttribute('aria-disabled')!=='true')zoomAt(tgt.s*STEP,0,0) });
bOut&&bOut.addEventListener('click',()=>{ if(bOut.getAttribute('aria-disabled')!=='true')zoomAt(tgt.s/STEP,0,0) });

/* wheel and trackpad (a trackpad pinch arrives as a wheel event with ctrlKey) */
stage.addEventListener('wheel',e=>{
  e.preventDefault(); if(maxS<1.05)return;
  const dy=e.deltaY*(e.deltaMode===1?16:e.deltaMode===2?H:1);
  const f=Math.exp(-dy*(e.ctrlKey?.01:.0022));
  const [px,py]=rel(e.clientX,e.clientY); zoomAt(tgt.s*f,px,py,e.ctrlKey);
},{passive:false});

/* touch and mouse: drag, pinch, swipe, tap */
const pts=new Map(); let g=null, lastTap=0, lastX=0, lastY=0;
function begin(){
  cancelAnimationFrame(raf); raf=0; tgt={s:cur.s,x:cur.x,y:cur.y};
  const a=[...pts.values()];
  if(a.length===1)g={type:'pan',sx:a[0].x,sy:a[0].y,tx:cur.x,ty:cur.y,moved:false,dx:0,dy:0};
  else if(a.length>=2){ const m=rel((a[0].x+a[1].x)/2,(a[0].y+a[1].y)/2);
    g={type:'pinch',d:Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y)||1,s:cur.s,mx:m[0],my:m[1],tx:cur.x,ty:cur.y,moved:true} }
}
function settle(){
  const s=Math.min(maxS,Math.max(1,cur.s));
  if(s!==cur.s){ const r=s/cur.s; tgt.x=cur.x*r; tgt.y=cur.y*r } else { tgt.x=cur.x; tgt.y=cur.y }
  tgt.s=s; clampT(tgt); go();
}
stage.addEventListener('pointerdown',e=>{
  if(e.pointerType==='mouse'&&e.button!==0)return;
  try{stage.setPointerCapture(e.pointerId)}catch(_){}
  pts.set(e.pointerId,{x:e.clientX,y:e.clientY,type:e.pointerType}); begin();
});
stage.addEventListener('pointermove',e=>{
  if(!pts.has(e.pointerId)||!g)return;
  pts.set(e.pointerId,{x:e.clientX,y:e.clientY,type:e.pointerType});
  if(g.type==='pan'){
    const dx=e.clientX-g.sx, dy=e.clientY-g.sy; g.dx=dx; g.dy=dy;
    if(Math.hypot(dx,dy)>5)g.moved=true; if(!g.moved)return;
    if(cur.s>1.01){ zv.classList.add('is-dragging'); tgt.x=g.tx+dx; tgt.y=g.ty+dy; clampT(tgt); go(true) }
    else if(e.pointerType!=='mouse'&&dy>0&&dy>Math.abs(dx)){ cur.x=0; cur.y=dy*.6; img.style.opacity=String(1-Math.min(.5,dy/600)); apply() }   // pull down to close
    else if(N>1&&e.pointerType!=='mouse'){ cur.x=dx*.6; cur.y=0; img.style.opacity=''; apply() }   // swipe: the photo follows a little
  }else{
    const a=[...pts.values()]; if(a.length<2)return;
    const d=Math.hypot(a[0].x-a[1].x,a[0].y-a[1].y), m=rel((a[0].x+a[1].x)/2,(a[0].y+a[1].y)/2);
    let s=g.s*d/g.d;
    if(s>maxS)s=maxS*(1+Math.min(.08,(s/maxS-1)*.25));      // soft stop at the sharpest point
    if(s<1)s=1-Math.min(.12,(1-s)*.3);
    const r=s/g.s; cur.s=tgt.s=s; cur.x=tgt.x=m[0]-(g.mx-g.tx)*r; cur.y=tgt.y=m[1]-(g.my-g.ty)*r;
    apply(); state(); big(s);
  }
});
function end(e){
  if(!pts.has(e.pointerId))return;
  const p=pts.get(e.pointerId); pts.delete(e.pointerId);
  const was=g; zv.classList.remove('is-dragging');
  if(pts.size>0){ begin(); if(g)g.moved=true; return }   // pinch -> one finger left: keep moving, never a tap
  g=null; if(!was)return;
  if(was.type==='pan'&&!was.moved&&e.type==='pointerup'){
    const now=Date.now();
    if(p.type==='mouse'){ toggle(e.clientX,e.clientY) }
    else if(now-lastTap<320&&Math.hypot(e.clientX-lastX,e.clientY-lastY)<30){ lastTap=0; toggle(e.clientX,e.clientY); return }
    else{ lastTap=now; lastX=e.clientX; lastY=e.clientY }
    return;
  }
  img.style.opacity='';
  if(was.type==='pan'&&cur.s<=1.01&&p.type!=='mouse'&&was.dy>90&&was.dy>Math.abs(was.dx)){ close(); return }   // swiped down
  if(was.type==='pan'&&cur.s<=1.01&&N>1&&Math.abs(was.dx)>50&&p.type!=='mouse'){ show(idx+(was.dx<0?1:-1)); return }
  settle();
}
stage.addEventListener('pointerup',end);
stage.addEventListener('pointercancel',end);
function toggle(cx,cy){
  if(maxS<1.05)return;
  if(tgt.s>1.01){ reset() } else { const [px,py]=rel(cx,cy); zoomAt(Math.min(maxS,CLOSE_VIEW),px,py) }
}

/* keyboard (while open): Esc, Tab kept inside, arrows (change photo, or move the zoomed photo), + − 0 */
const FOC='button:not([disabled])';
document.addEventListener('keydown',e=>{   // on the document: after a drag, focus can rest on <body>
  if(!isOpen)return;
  if(e.key==='Escape'){e.preventDefault(); close(); return}
  if(e.key==='Tab'){ const f=[...zv.querySelectorAll(FOC)].filter(el=>el.offsetParent!==null&&!el.closest('[hidden]')); if(!f.length)return;
    const first=f[0], last=f[f.length-1];
    if(e.shiftKey&&document.activeElement===first){e.preventDefault(); last.focus()}
    else if(!e.shiftKey&&document.activeElement===last){e.preventDefault(); first.focus()}
    else if(!zv.contains(document.activeElement)){e.preventDefault(); first.focus()}
    return }
  const zoomed=tgt.s>1.01, step=Math.round(Math.min(W,H)*.15);
  switch(e.key){
    case 'ArrowLeft': e.preventDefault(); if(zoomed){tgt.x+=step; clampT(tgt); go()} else if(N>1)show(idx-1); break;
    case 'ArrowRight': e.preventDefault(); if(zoomed){tgt.x-=step; clampT(tgt); go()} else if(N>1)show(idx+1); break;
    case 'ArrowUp': if(zoomed){e.preventDefault(); tgt.y+=step; clampT(tgt); go()} break;
    case 'ArrowDown': if(zoomed){e.preventDefault(); tgt.y-=step; clampT(tgt); go()} break;
    case '+': case '=': e.preventDefault(); zoomAt(tgt.s*STEP,0,0); break;
    case '-': case '_': e.preventDefault(); zoomAt(tgt.s/STEP,0,0); break;
    case '0': e.preventDefault(); reset(); break;
  }
});
addEventListener('resize',()=>{ if(!isOpen)return; const s=tgt.s; fit(); tgt.s=Math.min(s,maxS); clampT(tgt); go(true) });
})();

/* 29 Oct (design audit R1): laptop info column. Sticky under the header when it fits the screen;
   when it is taller, it scrolls with the page and sticks once its last line is in view (top = screen − height).
   Nothing is hidden in an inner scroll box any more.
   Fix round 2 (30 Oct, designer #10): the photo column follows the same rule, so a piece with few photos (shorter than the words)
   keeps its photos in view instead of leaving a large empty column on the left (aa-product.css). */
(()=>{
  const cols=[...document.querySelectorAll('.aa-pdp__info,.aa-pdp__media')].filter(el=>!el.dataset.aaStick); if(!cols.length)return;
  cols.forEach(el=>{el.dataset.aaStick='1'});
  const mq=matchMedia('(min-width:1000px)'); let raf=0;
  const set=()=>{ raf=0;
    cols.forEach(el=>{
      if(!mq.matches){ el.style.top=''; return }
      el.style.top='';
      const hd=parseFloat(getComputedStyle(el).top)||0, vh=innerHeight, h=el.offsetHeight;
      el.style.top=(h+hd>vh ? Math.round(vh-h) : hd)+'px';
    });
  };
  const q=()=>{ if(!raf)raf=requestAnimationFrame(set) };
  addEventListener('resize',q,{passive:true});
  if(mq.addEventListener)mq.addEventListener('change',q);
  if('ResizeObserver' in window){const ro=new ResizeObserver(q); cols.forEach(el=>ro.observe(el))}
  q();
})();
